import { defineMessages } from 'react-intl';

export const scope = 'app.base.component.custom_dropdown';

export default defineMessages({
  add: {
    id: `${scope}.add`,
    defaultMessage: 'Add',
  },
  no_results_found: {
    id: `${scope}.no_results_found`,
    defaultMessage: 'No results found',
  },
});
